import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PageIndexService {
  public getPageIndex(clazz: string) {
    let toReturn = localStorage.getItem(clazz + '-page');
    return toReturn == null ? null : Number.parseInt(toReturn);
  }

  public setPageIndex(clazz: string, page: number) {
    localStorage.setItem(clazz + '-page', page.toString());
  }

  public getPageSize(clazz: string) {
    let toReturn = localStorage.getItem(clazz + '-size');
    return toReturn == null ? null : Number.parseInt(toReturn);
  }

  public setPageSize(clazz: string, size: number) {
    localStorage.setItem(clazz + '-size', size.toString());
  }
}

export const PAGE_SIZE_OPTIONS = [5, 10, 30, 50, 100];
export const PAGE_SIZE_OPTIONS_IMMO = [...PAGE_SIZE_OPTIONS, 200];
